import Box from "@mui/material/Box";
import { resource } from "../../utility/constants/resource/resource";
import IconList from "../../icons/IconList";
const MainTopView = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <IconList />
    </Box>
  );
};
export default MainTopView;
